import React, { useState } from "react";
import api from "../../../api";
import { Helmet } from "react-helmet-async";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");
    setLoading(true);

    try {
      const response = await api.post("/auth/forgot-password", {
        email,
      });

      setMessage(
        response.data?.message ||
          "Si un compte existe avec cette adresse, un email a été envoyé."
      );

      setEmail("");
    } catch (err) {
      console.error(err);

      setError(
        err.response?.data?.message ||
          "Erreur lors de l'envoi du lien de réinitialisation."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Helmet>
      <title>Connexion | LMFP Photography</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
        
    <div className="flex min-h-full items-center justify-center px-4 py-10">
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900 p-6 text-white shadow-lg">
        <h1 className="mb-2 text-center text-2xl font-bold">
          Mot de passe oublié
        </h1>

        <p className="mb-6 text-center text-sm text-slate-400">
          Entrez votre adresse email pour recevoir un lien de réinitialisation.
        </p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="mb-2 block text-sm font-medium text-slate-200">
              Email
            </label>

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre adresse email"
              className="w-full rounded-xl border border-slate-700 bg-slate-950 px-4 py-3 text-white outline-none transition focus:border-orange-500"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl bg-orange-500 px-4 py-3 font-semibold text-white transition hover:bg-orange-600 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? "Envoi en cours..." : "Envoyer le lien"}
          </button>
        </form>

        {message && (
          <div className="mt-5 rounded-xl border border-green-500/30 bg-green-500/10 px-4 py-3 text-center text-sm text-green-300">
            {message}
          </div>
        )}

        {error && (
          <div className="mt-5 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-center text-sm text-red-300">
            {error}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default ForgotPassword;